import { Validators, FormArray, FormControl, FormGroup } from '@angular/forms';
import {
  getOrg,
  getValue,
  getDate,
  getActivity,
  getLablel,
  PARRENT_MARK,
  getScore
} from '../mappers';
import {
  IAutocompleteCtx,
  IAvatar,
  IDateCtx,
  IInputCtx,
  IMultiTagsCtx,
  ITextCtx
} from '../../shared/form';
import { AutoCompleteService } from '../../core/services/autocomplete.service';

import { AutocompleteService as AutocompleteService2 } from 'src/app/shared/modules/autocomplete/services/autocomplete/autocomplete.service';

import { IOption } from '../organization/organization.service';
import { debounceTime, filter, map, switchMap } from 'rxjs/operators';
import { ICheckboxCtx } from '../../shared/form/checkbox/checkbox.component';
import { AppTagsComponent } from '../../shared/modules/form/components';
import { RegistrationStudentForm } from '../../modules/registration/modules/registration-student/components/registration-student.form';
import { animationFrameScheduler, of, scheduled } from 'rxjs';

export class StudentForm {
  readonly fields = {
    name: new FormControl(null, [Validators.required]),
    lastName: new FormControl(null, [Validators.required]),
    born: new FormControl(null, [Validators.required]),
    country: new FormControl(null, [Validators.required]),
    city: new FormControl(null, [Validators.required]),
    currentschool: new FormControl(null, [Validators.required]),
    address: new FormControl(null, [Validators.required]),
    zip: new FormControl(''),
    // extraInterests: new FormArray(
    //   [],
    //   [Validators.required, Validators.minLength(1)]
    // ),
    interests: new FormGroup({
      new: new FormControl(
        null,
        [],
        [
          (control) => {
            if (!control.parent) {
              return of(null);
            }

            return scheduled(of(null), animationFrameScheduler).pipe(
              map((_) =>
                control.parent.get('list').valid
                  ? null
                  : {
                      forbidden: { message: 'Should add at least one interest' }
                    }
              )
            );
          }
        ]
      ),
      list: new FormControl([], [Validators.required, Validators.minLength(1)])
    }),
    afterschool: new FormArray([]),
    otherexperience: new FormArray([]),
    tests: new FormArray([]),
    honorsandavards: new FormArray([]),
    previosschool: new FormArray([]),
    language: new FormArray([]),
    about_me: new FormControl(),
    parrentsName: new FormControl(),
    parrentsVerify: new FormControl()
  };

  readonly form = new FormGroup(this.fields);

  public avatar: IAvatar;
  readonly storageId = `student`;

  readonly firstName: IInputCtx = {
    control: this.fields.name,
    placeholder: `First Name`
  };

  readonly lastName: IInputCtx = {
    control: this.fields.lastName,
    placeholder: `Last Name`
  };

  readonly parrent: IInputCtx = {
    control: this.fields.parrentsName,
    placeholder: `Parrent's name`
  };

  readonly parrentVerify: ICheckboxCtx = {
    control: this.fields.parrentsVerify,
    placeholder: ''
  };

  readonly birthDate: IDateCtx = {
    control: this.fields.born,
    placeholder: `Birth Date`,
    start: new Date(2000, 0, 1),
    isInputDisabled: true
  };

  readonly country = this.auto.getCountry(this.fields.country);
  readonly city = this.auto.getCity(this.fields.city);
  readonly zip: IInputCtx = {
    control: this.fields.zip,
    placeholder: `Zip / Post Code`
  };
  readonly institution: IAutocompleteCtx<IOption> = {
    control: this.fields.currentschool,
    placeholder: `Current school`,
    hint: 'Rushmore Academy',
    getTitle: getValue,
    getOptionTitle: getLablel,
    options: this.auto.getOptions(this.fields.currentschool, `autocomplete/org`)
  };

  readonly address: IInputCtx = {
    control: this.fields.address,
    placeholder: `Address`
  };

  readonly aboutMe: ITextCtx = {
    control: this.fields.about_me,
    placeholder: `About me`,
    maxLength: 250
  };

  // readonly interestsTags: IMultiTagsCtx<any> = {
  //   inputs: [
  //     this.auto.getAutocomplete(
  //       `Interests`,
  //       `get/field/interest`,
  //       `Biology, Tennis`
  //     )
  //   ],
  //   getTitle: (interest) => `${interest}`,
  //   map: ([interest]) =>
  //     getValue(interest)
  //       .split(`,`)
  //       .map((value) => value.trim()),
  //   values: this.fields.extraInterests
  // };

  readonly interestsTags: AppTagsComponent.IContext<RegistrationStudentForm.ITag> =
    {
      control: this.fields.interests.get('new') as FormControl,
      placeholder: 'Interests',
      hint: 'Biology, Tennis',
      optionTitle: (_) => _?.title || '',
      options$: this.fields.interests.get('new').valueChanges.pipe(
        debounceTime(300),
        switchMap((_: string) => this.autoCompleteService.interests(_))
      ),
      values$: this.fields.interests.get('list').valueChanges,
      onSelect: (_) => this.onSelectInterest(_),
      onAdd: () => {},
      onRemove: (_) => this.onRemoveInterest(_)
    };

  readonly extracurricular: IMultiTagsCtx<any> = {
    inputs: [
      this.auto.getAutocomplete(
        `Extracurricular & After school`,
        ``,
        `Soccer (forward)`
      ),
      this.auto.getAutocomplete(
        `Organization`,
        `autocomplete/org`,
        `Rushmore Academy`
      ),
      this.auto.getAutocomplete(`Address`, ``)
    ],
    map: getActivity,
    getTitle: (activity) => `${activity.name} @ ${activity.body.name}`,
    values: this.fields.afterschool
  };

  readonly work: IMultiTagsCtx<any> = {
    inputs: [
      this.auto.getAutocomplete(
        `Work & other experience`,
        `get/field/otherexperience`,
        `Volunteer`
      ),
      this.auto.getAutocomplete(
        `Organization`,
        `autocomplete/org`,
        `NYC Public Library`
      ),
      this.auto.getAutocomplete(`Address`, ``)
    ],
    getTitle: (activity) => `${activity.name} @ ${activity.body.name}`,
    map: getActivity,
    values: this.fields.otherexperience
  };

  readonly tests: IMultiTagsCtx<any> = {
    inputs: [
      this.auto.getAutocomplete(`Test scores & GPA`, ``, `SAT`),
      this.auto.getAutocomplete(`Grade`, ``, `1340`)
    ],
    map: getScore,
    getTitle: ({ name, value }) => `${name} @ ${value}`,
    values: this.fields.tests
  };

  readonly honors: IMultiTagsCtx<any> = {
    inputs: [
      this.auto.getAutocomplete(
        `Honors & awards`,
        `get/field/honorsandavards`,
        `Third Prize`
      ),
      this.auto.getAutocomplete(
        `Contest or Event`,
        `autocomplete/org`,
        `Science Fair`
      ),
      this.auto.getAutocomplete(`Address`, ``)
    ],
    map: getActivity,
    getTitle: (activity) => `${activity.name} @ ${activity.body.name}`,
    values: this.fields.honorsandavards
  };

  readonly previous: IMultiTagsCtx<any> = {
    inputs: [
      this.auto.getAutocomplete(
        `Previous educational institutions`,
        `autocomplete/org`
      ),
      this.auto.getAutocomplete(`Address`, ``)
    ],
    getTitle: (school) => `${school.name}`,
    map: ([organization, address]) => getOrg(organization, address),
    values: this.fields.previosschool
  };

  readonly languages: IMultiTagsCtx<any> = {
    inputs: [
      this.auto.getAutocomplete(
        `Spoken languages`,
        `get/field/language`,
        `English, Spanish`
      )
    ],
    getTitle: (language) => `${language}`,
    map: ([language]) => getValue(language),
    values: this.fields.language
  };

  constructor(
    readonly auto: AutoCompleteService,
    readonly autoCompleteService: AutocompleteService2
  ) {
    this.checkParrent();

    this.auto.lockOrg(this.fields.currentschool, this.fields.address, true);

    this.auto.lockOrg(this.work.inputs[1].control, this.work.inputs[2].control);

    this.auto.lockOrg(
      this.extracurricular.inputs[1].control,
      this.extracurricular.inputs[2].control
    );

    this.auto.lockOrg(
      this.honors.inputs[1].control,
      this.honors.inputs[2].control
    );

    this.auto.lockOrg(
      this.previous.inputs[0].control,
      this.previous.inputs[1].control
    );
  }

  public getFormData() {
    const object = this.form.value;
    const mapped = {
      currentschool: getOrg(object.currentschool, object.address),
      scores_name: [],
      scores_value: [],
      // interest: [],
      interest: this.fields.interests.get('list').value.map((_) => _.title),
      zip: object.zip,
      born: getDate(object.born),
      name: object.name,
      lastname: object.lastName,
      country: getValue(object.country),
      city: getValue(object.city),
      afterschool: object.afterschool,
      otherexperience: object.otherexperience,
      honorsandavards: object.honorsandavards,
      previosschool: object.previosschool,
      language: object.language,
      about_me: object.about_me,
      ...(this.avatar ?? {})
    };

    for (const score of object.tests) {
      mapped['scores_name'].push(score.name);
      mapped['scores_value'].push(score.value);
    }

    // mapped.interest = [
    //   ...(object.extraInterests ?? [])
    //   // ...object.interests,
    //   // ...object.intrestedColleges,
    //   // ...object.intrestedMajors
    // ];

    if (this.isParrent) {
      mapped['name_parents'] = object.parrentsName;
    }

    return mapped;
  }

  public isParrent = false;
  protected checkParrent() {
    const mark = localStorage.getItem(PARRENT_MARK);

    if (!mark) return; // #Return#

    this.isParrent = true;
    this.fields.parrentsName.setValidators([Validators.required]);

    this.fields.parrentsVerify.setValidators([Validators.requiredTrue]);
  }

  private onSelectInterest(data: { title: string }) {
    this.fields.interests.get('new').setValue(null);

    this.fields.interests
      .get('list')
      .setValue([
        ...this.fields.interests.get('list').value,
        { title: data.title }
      ]);
  }

  private onRemoveInterest(index: number) {
    const values = [...this.fields.interests.get('list').value];
    values.splice(index, 1);

    this.fields.interests.get('list').setValue(values);
  }
}
